import { monitorSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function MonitorMethod() {
  return (
    <section id="method" className="w-full border-b border-background-200 bg-background-100 py-10 md:py-14">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <SectionHeading
          no="06"
          title="风险是怎么被监控的"
          desc="不靠玄学，也不靠单条爆料。我们把公开线索按固定流程过一遍，让「感觉有风险」变成「知道风险在哪、影响哪条合作」。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <div className="overflow-hidden rounded-lg bg-foreground-950">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20editorial%20visual%20of%20a%20risk%20monitoring%20workflow%2C%20connected%20nodes%20and%20layered%20charts%20on%20a%20dark%20charcoal%20background%2C%20deep%20crimson%20and%20warm%20amber%20highlights%2C%20minimal%20studio%20light%2C%20clean%20geometric%20composition%2C%20high%20detail&width=1000&height=760&seq=method-visual-01&orientation=landscape"
                alt="17黑料网风险监控流程示意"
                title="17黑料网代言风险监控流程"
                className="h-56 w-full object-cover object-top opacity-90 md:h-64"
              />
              <div className="p-5 md:p-6">
                <h4 className="font-heading text-lg font-bold text-background-50">把零散信号拼成一张地图</h4>
                <p className="mt-2 text-sm leading-relaxed text-background-200">
                  单个讨论没有意义，但当讨论、客服反馈和渠道动作同时指向同一个合作时，那就是值得提前处理的信号。
                  17黑料网做的，是把这些信号归位到具体的品牌与代言关系上。
                </p>
                <div className="mt-5 grid grid-cols-3 gap-3 border-t border-background-50/15 pt-5 text-center">
                  {[
                    { k: "监控维度", v: "18" },
                    { k: "日均线索", v: "120+" },
                    { k: "预警提前量", v: "3-14 天" },
                  ].map((s) => (
                    <div key={s.k}>
                      <p className="font-heading text-lg font-black text-background-50">{s.v}</p>
                      <p className="mt-0.5 text-[11px] text-background-400">{s.k}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {monitorSteps.map((s) => (
                <article
                  key={s.step}
                  className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5"
                >
                  <span className="font-heading text-2xl font-black text-primary-300">{s.step}</span>
                  <h4 className="mt-2 font-heading text-base font-bold text-foreground-950">{s.title}</h4>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{s.desc}</p>
                </article>
              ))}
            </div>

            <div className="mt-4 flex flex-wrap items-center gap-3 rounded-lg border border-secondary-200 bg-secondary-50 p-4">
              <i className="ri-shield-star-line w-6 h-6 flex items-center justify-center text-xl text-secondary-600"></i>
              <p className="flex-1 text-xs leading-relaxed text-foreground-700">
                <strong className="text-foreground-900">信息边界：</strong>
                本站仅整理公开可获取的讨论与行业反馈，用于合作前的风险参考，不对任何个人或品牌作出事实认定。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}